import * as React from 'react';
import * as moment from 'moment-timezone';
import { compose, withProps, withHandlers } from 'recompose';
import { ReportSettings, ReportSettingsChangeHandler } from 'logic/reports/ReportSettings';
import { Select } from 'ui/shared/Select';
import { times } from 'util/times';

export type OwnProps = {
    reportSettings: Readonly<ReportSettings>;
    onChange: ReportSettingsChangeHandler;
};

const RawHourOptions = ({ selected, onChangeHours }: Props) =>
    <Select
        id="edit-report-face-rec-hours"
        multiple={ true }
        value={ selected as string[] }
        onChange={ onChangeHours }
    >
        { times(24, hour =>
            <option
                key={ `${hour}` }
                value={ hour }
            >
                { moment().startOf('day').add('hours', hour).format('LT') }
            </option>
        ) }
    </Select>
;

type RecomposeProps = {
    selected: ReadonlyArray<string>;
    onChangeHours: React.ChangeEventHandler<HTMLSelectElement>;
};

type Props = RecomposeProps;

export const HourOptions = compose<Props, OwnProps>(
    withProps<Partial<RecomposeProps>, OwnProps>(({ reportSettings }) => ({
        selected: reportSettings.hourOptions.split(','),
    })),
    withHandlers<OwnProps, Partial<RecomposeProps>>({
        onChangeHours: ({ onChange }) => (e: React.ChangeEvent<HTMLSelectElement>) => {
            const optionsArray: ReadonlyArray<HTMLOptionElement> = Array.apply(null, e.currentTarget.options); // Convert into an Array
            const hourOptions = optionsArray.filter((o: HTMLOptionElement) => o.selected).map(o => o.value).join(',');
            onChange(reportSettings => reportSettings.setHourOptions(hourOptions));
        },
    }),
)(RawHourOptions);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/faceRec/HourOptions.tsx